import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';

import { SharedPlaylistPreviewItemComponent } from './playlist-preview-item.component';
import { ImagePreloadModule } from '../../directives/image-preload/image-preload.module';
import { SpinnerModule } from 'src/app/system/spinner/spinner.module';

@NgModule({
  declarations: [
    SharedPlaylistPreviewItemComponent
  ],
  imports: [
    CommonModule,
    MatMenuModule,
    ImagePreloadModule,
    SpinnerModule
  ],
  exports: [
    SharedPlaylistPreviewItemComponent
  ]
})
export class SharedPlaylistPreviewItemModule { }
